module.exports = __webpack_public_path__ + "media/images/landing/second/photo20-bf6d20655a581c3ab1046e7f030cccde.jpg";